import FleetCoachTask from "../../../views/FleetCoachTask";
import FleetCoachTaskV2 from "../../../views/FleetCoachTaskV2";
import MenuNames from "../../../constants/Menu/MenuNames.json";

export default [
  {
    menuName: MenuNames.FLEET_COACH_TASK,
    path: "/fleet-coach-task",
    component: FleetCoachTask,
    exact: true,
  },
  {
    menuName: MenuNames.FLEET_COACH_TASK_V2,
    path: "/v2/fleet-coach-task",
    component: FleetCoachTaskV2,
    exact: true,
  },
];
